import { render, staticRenderFns } from "./DialogInfoCell.vue?vue&type=template&id=1fdba536&"
import script from "./DialogInfoCell.vue?vue&type=script&lang=babel&"
export * from "./DialogInfoCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports